// React Imports
import { StyleSheet, ActivityIndicator } from "react-native";

// Third-party Imports
import { BlurView } from "expo-blur";

// Type Imports
import type { ChildrenType } from "@core/types";

type Props = ChildrenType & {
  loading: boolean;
};

export default function Loading({ children, ...props }: Props) {
  if (!props.loading) {
    return children;
  }

  return (
    <BlurView style={styles.blur} intensity={10}>
      <ActivityIndicator size="small"></ActivityIndicator>
    </BlurView>
  );
}

const styles = StyleSheet.create({
  blur: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    minHeight: 32,
    minWidth: 32,
  },
});
